import React from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MasterDataLayout from './components/MasterDataLayout/index.jsx';
import Dashboard from './pages/Dashboard/index.jsx';
import Seasons from './pages/Seasons/index.jsx';
import CreateSeasons from './pages/Seasons/CreateSeasons.jsx';
import Dealer from './pages/Dealer/index.jsx';
import CreateDealer from './pages/Dealer/createDealer.jsx';
import Location from './pages/Location/index.jsx';
import CropVarietyIndex from './pages/cropVariety/index.jsx';
import CreateCrop from './pages/cropVariety/CreateCrop.jsx';
import CreateVariety from './pages/cropVariety/CreateVariety.jsx';
import PreActivity from './pages/Preactivity/PreActivity.jsx';
import AddTarget from './pages/Preactivity/AddTarget.jsx';
import User from './pages/Users/index.jsx';
import FarmerManagement from './pages/Former/index.jsx';
import FarmerCreation from './pages/Former/create.jsx';
import PostActivity from './pages/postActivity/index.jsx';
import CreatePostActivity from './pages/postActivity/createPostActivity.jsx';
import SalesTarget from './pages/salesTarget/index.jsx';
import AMRMActivitiesTabs from './pages/AMRM/AMRMActivitiesTabs.jsx';
import CreateSalesTarget from './pages/salesTarget/createSalesTarget.jsx';
import SuperAdminLayout from './components/SuperAdminLayout/index.jsx';
import SuperAdminDashboard from './pages/SuperAdmin/SuperAdminDashboard.jsx';
import SuperAdminLogin from './pages/SuperAdmin/SuperAdminLogin.jsx';
import AdminCreation from './pages/SuperAdmin/AdminCreation.jsx';
import SuperAdminUserManagement from './pages/SuperAdmin/SuperAdminUserManagement.jsx';
import UserDetailsVeiw from './pages/SuperAdmin/UserDetailsVeiw.jsx';
import LoginModel from './components/loginLayouts/loginModel.jsx';
import OtpLogin from './components/loginLayouts/otpLogin.jsx';
import UserInformation from './pages/Users/createUser.jsx';
import NotFound from './pages/NotFound.jsx';
import SOorMDOLayout from './components/SOorMDOLayout/index.jsx';
import FarmerCommitment from './pages/SOorMDO/farmerComitment/index.jsx';
import FarmerRegister from './pages/SOorMDO/farmerComitment/registerFarmer.jsx';
import PostSaleRegister from './pages/SOorMDO/farmerComitment/PostSaleRegister.jsx';
import FarmerReferenceLead from './pages/SOorMDO/farmerReferenceLead/index.jsx';
import SOorMDOPreActivity from './pages/SOorMDO/preActivitySOMDO/index.jsx';
import SOorMDOPostActivity from './pages/SOorMDO/postActivitySOMDO/index.jsx';
import SOorMDOSalesTarget from './pages/SOorMDO/salesTargetSOMDO/index.jsx';
import ActivitiesTabs from './pages/SOorMDO/Activities/index.jsx';
import Activity from './pages/SOorMDO/preActivitySOMDO/activity.jsx';
import ViewPreActivity from './pages/SOorMDO/preActivitySOMDO/viewPreActivity.jsx';
import ViewPostActivity from './pages/SOorMDO/postActivitySOMDO/viewPostActivity.jsx';
import SoActivity from './pages/SOorMDO/postActivitySOMDO/activity.jsx';
import Profile from './components/profile/index.jsx';
import Home from './pages/home.jsx';
import Layout from './components/Layout/index.js';
import AdminProtectedRoute from './components/HOC/AdminProtectedRoute.jsx';
import SoProtectedRoute from './components/HOC/SoProtectedRoute.jsx';
import UserProtectedRoutes from './components/HOC/UserProtectedRoutes.jsx';
import TravelPunchingLog from './pages/SOorMDO/travelPunchingLog/index.jsx';
import AMRMLayout from './components/AMRMLayout/index.jsx';
import PreActivityAMRM from './pages/AMRM/preActivityAmRm/index.jsx';
import CreatePreActivityAMRM from './pages/AMRM/preActivityAmRm/createActivity.jsx';
import PostActivityAMRM from './pages/AMRM/postActivityAmRm/index.jsx';
import CreatePostActivityAMRM from './pages/AMRM/postActivityAmRm/createActivity.jsx';
import SalesTargetAMRM from './pages/AMRM/SalesTarget/index.jsx';
import CreateSalesTargetAMRM from './pages/AMRM/SalesTarget/createSalesTarget.jsx';
import DailyActivityAMRM from './pages/AMRM/dailyActivityAmRm/index.jsx';
import TravelPunchingLogAMRM from './pages/AMRM/dailyActivityAmRm/TravelPunchingLog.jsx';
import TravelPunchingLogList from './pages/SOorMDO/travelPunchingLog/TravelPunchingLogList.jsx';
import DailyTaskList from './pages/DailyTask/index.jsx';
import CreateTask from './pages/DailyTask/createTask.jsx';
import EditTask from './pages/DailyTask/editTask.jsx';
import TasksTabs from './pages/SOorMDO/tasks/index.jsx';
import PreSeasonAMRMInformation from './pages/AMRM/preActivityAmRm/createActivity.jsx';
import AMRMFarmerCreation from './pages/AMRM/farmerRegistration/registerFarmer.jsx';
import AMRMFarmerManagement from './pages/AMRM/farmerRegistration/index.jsx';
import AMRMTasksTabs from './pages/AMRM/AMRMTaskTabs/index.jsx';
import TravelPunchingLogView from './pages/SOorMDO/travelPunchingLog/TravelPunchingLogView.jsx';
import TravelPunchingLogViewAMRM from './pages/AMRM/dailyActivityAmRm/TravelPunchingLogViewAMRM.jsx';
import SOorMDODashboard from './pages/SOorMDO/dashBoard/index.jsx';
import ForgotPasswordModal from './components/loginLayouts/forgotPassword.jsx';
import InstallBanner from './components/InstallApp/InstallBanner.jsx';
import SaleRegister from './pages/Former/SalesRegister.jsx';

function App() {
  return (
    <Router>
      <InstallBanner />
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <Routes>
        {/* Public layout routes */}
        <Route path='/' element={<Layout />}>
          {/* Index: redirect logged-in users to their role dashboard, show Home if not logged in */}
          <Route index element={<UserProtectedRoutes component={Home} />} />
          {/* Always public — never protected */}
          <Route path='login' element={<LoginModel />} />
          <Route path='otpLogin' element={<OtpLogin />} />
          <Route path='forgotPassword' element={<ForgotPasswordModal />} />
          <Route path='profile' element={<Profile />} />
        </Route>

        <Route path='/masterData' element={<AdminProtectedRoute component={MasterDataLayout} />}>
          <Route index element={<Navigate to="/masterData/dashboard" replace />} />
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='user' element={<User />} />
          <Route path='usercreate' element={<UserInformation />} />
          <Route path='seasons' element={<Seasons />} />
          <Route path='seasonscreate' element={<CreateSeasons />} />
          <Route path='dealer' element={<Dealer />} />
          <Route path='createDealer' element={<CreateDealer />} />
          <Route path='location' element={<Location />} />
          <Route path='cropVariety' element={<CropVarietyIndex />} />
          <Route path='cropcreate' element={<CreateCrop />} />
          <Route path='createVariety' element={<CreateVariety />} />
          <Route path='preActivity' element={<PreActivity />} />
          <Route path='addTarget' element={<AddTarget />} />
          <Route path='farmer' element={<FarmerManagement />} />
          <Route path='createFarmer' element={<FarmerCreation />} />
          <Route path = 'salesRegister' element={<SaleRegister/>} />
          <Route path='postActivity' element={<PostActivity />} />
          <Route path='createPostActivity' element={<CreatePostActivity />} />
          <Route path='salesTarget' element={<SalesTarget />} />
          <Route path='createSalesTarget' element={<CreateSalesTarget />} />
          <Route path='travelPunchingLog' element={<TravelPunchingLog />} />
          <Route path='travelPunchingLogList' element={<TravelPunchingLogList />} />
          <Route path='travelPunchingLog/view/:id' element={<TravelPunchingLogView />} />
          <Route path='dailyTask' element={<DailyTaskList />} />
          <Route path='dailyTaskcreate' element={<CreateTask />} />
          <Route path='dailyTaskedit' element={<EditTask />} />
        </Route>

         <Route path='/SOorMDO' element={<SoProtectedRoute component={SOorMDOLayout} />}>
          <Route index element={<Navigate to="/SOorMDO/dashboard" replace />} />
          <Route path='dashboard' element={<SOorMDODashboard />} />
          <Route path='farmerCommitment' element={<FarmerCommitment />} />
          <Route path='farmerCommitment/registerFarmer' element={<FarmerRegister />} />
          <Route path='farmerCommitment/postSaleRegister' element={<PostSaleRegister />} />
          <Route path='farmerReferenceLead' element={<FarmerReferenceLead />} />
          <Route path='activities' element={<ActivitiesTabs />} />
          <Route path='tasks' element={<TasksTabs />} />
          <Route path='preActivity' element={<SOorMDOPreActivity />} />
          <Route path='viewPreActivity' element={<ViewPreActivity />} />
          <Route path='postActivity' element={<SOorMDOPostActivity />} />
          <Route path='salesTarget' element={<SOorMDOSalesTarget />} />
          <Route path='viewPostActivity' element={<ViewPostActivity />} />
          <Route path='createPostActivity' element={<SoActivity />} />
          <Route path='createActivity' element={<Activity />} />
          <Route path='travelPunchingLog' element={<TravelPunchingLog />} />
          <Route path='travelPunchingLogList' element={<TravelPunchingLogList />} />
          <Route path='travelPunchingLog/view/:id' element={<TravelPunchingLogView />} />
          <Route path='dailyTask' element={<DailyTaskList />} />
          <Route path='dailyTaskcreate' element={<CreateTask />} />
          <Route path='dailyTaskedit' element={<EditTask />} />
        </Route>

        <Route path='/amrm' element={<SoProtectedRoute component={AMRMLayout} />}>
          <Route index element={<Navigate to="/amrm/farmerManagement" replace />} />
          <Route path='activities' element={<AMRMActivitiesTabs />} />
          <Route path='tasks' element={<AMRMTasksTabs />} />
          
          {/* Pre Activity Routes */}
          <Route path='preActivity' element={<PreActivityAMRM />} />
          <Route path='preSeasonInformation' element={<PreSeasonAMRMInformation />} />
          <Route path='preActivitycreate' element={<CreatePreActivityAMRM />} />
          <Route path='preActivityview' element={<CreatePreActivityAMRM />} />
          
          {/* Post Activity Routes */}
          <Route path='postActivity' element={<PostActivityAMRM />} />
          <Route path='postActivity/create' element={<CreatePostActivityAMRM />} />
          <Route path='postActivity/edit/:activityId' element={<CreatePostActivityAMRM />} />
          
          {/* Sales Target Routes */}
          <Route path='salesTarget' element={<SalesTargetAMRM />} />
          <Route path='salesTarget/create' element={<CreateSalesTargetAMRM />} />
          <Route path='salesTarget/edit/:targetId' element={<CreateSalesTargetAMRM />} />
          
          {/* Daily Activity Routes */}
          <Route path='dailyActivity' element={<DailyActivityAMRM />} />
          <Route path='dailyActivity/punch' element={<TravelPunchingLogAMRM />} />
          <Route path='dailyActivityAMRM/punch/view/:id' element={<TravelPunchingLogViewAMRM />} />

          <Route path ='farmerManagement' element={<AMRMFarmerManagement />} />
          <Route path ='farmerManagementcreate' element={<AMRMFarmerCreation />} />
          
          {/* Daily Task Routes */}
          <Route path='dailyTask' element={<DailyTaskList />} />
          <Route path='dailyTaskcreate' element={<CreateTask />} />
          <Route path='dailyTaskedit' element={<EditTask />} />
        </Route>
        {/* </Route> */}

        <Route path='/superAdmin/login' element={<SuperAdminLogin />} />

        <Route path='/superAdmin' element={<SuperAdminLayout />}>
          <Route index element={<Navigate to="/superAdmin/dashboard" replace />} />
          <Route path='dashboard' element={<SuperAdminDashboard />} />
          <Route path='adminCreation' element={<AdminCreation />} />
          <Route path='userManagement' element={<SuperAdminUserManagement />} />
          <Route path='userDetailsView' element={<UserDetailsVeiw />} />
        </Route>

       
        {/* Fallback route */}
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
